module.exports = __webpack_public_path__ + "static/media/grafico.96e28b07.svg";